/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AdditionalCharge } from "./AdditionalCharge";
import {
  AdditionalChargeFromJSON,
  AdditionalChargeFromJSONTyped,
  AdditionalChargeToJSON,
  AdditionalChargeToJSONTyped,
} from "./AdditionalCharge";
import type { Coupon } from "./Coupon";
import {
  CouponFromJSON,
  CouponFromJSONTyped,
  CouponToJSON,
  CouponToJSONTyped,
} from "./Coupon";
import type { CustomerInvoice } from "./CustomerInvoice";
import {
  CustomerInvoiceFromJSON,
  CustomerInvoiceFromJSONTyped,
  CustomerInvoiceToJSON,
  CustomerInvoiceToJSONTyped,
} from "./CustomerInvoice";
import type { CarrierCreditNote } from "./CarrierCreditNote";
import {
  CarrierCreditNoteFromJSON,
  CarrierCreditNoteFromJSONTyped,
  CarrierCreditNoteToJSON,
  CarrierCreditNoteToJSONTyped,
} from "./CarrierCreditNote";
import type { CarrierInvoice } from "./CarrierInvoice";
import {
  CarrierInvoiceFromJSON,
  CarrierInvoiceFromJSONTyped,
  CarrierInvoiceToJSON,
  CarrierInvoiceToJSONTyped,
} from "./CarrierInvoice";

/**
 *
 * @export
 * @interface BillingTabData
 */
export interface BillingTabData {
  /**
   *
   * @type {Array<CarrierInvoice>}
   * @memberof BillingTabData
   */
  carrierInvoices: Array<CarrierInvoice>;
  /**
   *
   * @type {Array<Coupon>}
   * @memberof BillingTabData
   */
  couponsUsed: Array<Coupon>;
  /**
   *
   * @type {Array<CarrierCreditNote>}
   * @memberof BillingTabData
   */
  carrierCreditNotes: Array<CarrierCreditNote>;
  /**
   *
   * @type {Array<CustomerInvoice>}
   * @memberof BillingTabData
   */
  customerInvoices: Array<CustomerInvoice>;
  /**
   *
   * @type {Array<AdditionalCharge>}
   * @memberof BillingTabData
   */
  additionalCharges: Array<AdditionalCharge>;
  /**
   *
   * @type {Coupon}
   * @memberof BillingTabData
   */
  bestCoupon?: Coupon | null;
}

/**
 * Check if a given object implements the BillingTabData interface.
 */
export function instanceOfBillingTabData(
  value: object,
): value is BillingTabData {
  if (!("carrierInvoices" in value) || value["carrierInvoices"] === undefined)
    return false;
  if (!("couponsUsed" in value) || value["couponsUsed"] === undefined)
    return false;
  if (
    !("carrierCreditNotes" in value) ||
    value["carrierCreditNotes"] === undefined
  )
    return false;
  if (!("customerInvoices" in value) || value["customerInvoices"] === undefined)
    return false;
  if (
    !("additionalCharges" in value) ||
    value["additionalCharges"] === undefined
  )
    return false;
  return true;
}

export function BillingTabDataFromJSON(json: any): BillingTabData {
  return BillingTabDataFromJSONTyped(json, false);
}

export function BillingTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BillingTabData {
  if (json == null) {
    return json;
  }
  return {
    carrierInvoices: (json["carrierInvoices"] as Array<any>).map(
      CarrierInvoiceFromJSON,
    ),
    couponsUsed: (json["couponsUsed"] as Array<any>).map(CouponFromJSON),
    carrierCreditNotes: (json["carrierCreditNotes"] as Array<any>).map(
      CarrierCreditNoteFromJSON,
    ),
    customerInvoices: (json["customerInvoices"] as Array<any>).map(
      CustomerInvoiceFromJSON,
    ),
    additionalCharges: (json["additionalCharges"] as Array<any>).map(
      AdditionalChargeFromJSON,
    ),
    bestCoupon:
      json["bestCoupon"] == null
        ? undefined
        : CouponFromJSON(json["bestCoupon"]),
  };
}

export function BillingTabDataToJSON(json: any): BillingTabData {
  return BillingTabDataToJSONTyped(json, false);
}

export function BillingTabDataToJSONTyped(
  value?: BillingTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierInvoices: (value["carrierInvoices"] as Array<any>).map(
      CarrierInvoiceToJSON,
    ),
    couponsUsed: (value["couponsUsed"] as Array<any>).map(CouponToJSON),
    carrierCreditNotes: (value["carrierCreditNotes"] as Array<any>).map(
      CarrierCreditNoteToJSON,
    ),
    customerInvoices: (value["customerInvoices"] as Array<any>).map(
      CustomerInvoiceToJSON,
    ),
    additionalCharges: (value["additionalCharges"] as Array<any>).map(
      AdditionalChargeToJSON,
    ),
    bestCoupon: CouponToJSON(value["bestCoupon"]),
  };
}
